/* Dope Coffee gift ladder — cart progress meter + automatic free sachet.
 *
 * Mirrors the free-delivery bar (snippets/free-delivery-bar.liquid): same
 * --length / --max-length fill technique, same .free-delivery-bar__toolbar
 * furniture, so it reads as one system in the drawer and on the cart page.
 *
 * Thresholds are measured on the QUALIFYING total — the cart total minus any
 * gift lines we added ourselves — so a gift can never pay for its own tier.
 *
 * The free price is enforced by two Shopify automatic discounts (minimum
 * subtotal R3 000 / R5 000, 100% off that variant). This script only puts the
 * sachet in the cart; it never sets a price. If someone games the client the
 * discount simply does not apply and they pay full price — the safe failure.
 */
(function () {
  'use strict';

  // The snippet renders in both the cart drawer and the cart page, so this
  // file can be requested twice. Second copy must be inert.
  if (window.__cbCoffeeGift) return;
  window.__cbCoffeeGift = true;

  var BRAND = 'Dope Coffee';
  var TIERS = [
    { id: 43948769542356, threshold: 300000, short: '40mg', label: '40mg sachet', price: 16000 },
    { id: 43948769673428, threshold: 500000, short: '80mg', label: '80mg sachet', price: 26000 },
  ];

  /* "40mg & 80mg Dope Coffee" - never just "both", which never says of what. */
  function allTiersLabel() {
    return TIERS.map(function (t) { return t.short; }).join(' & ') + ' ' + BRAND;
  }

  // Both tiers stack: at R5 000 the member keeps the 40mg AND gains the 80mg.
  // Flip to false to make the rungs exclusive (best single reward only).
  var CUMULATIVE = true;

  var CUP = '<svg viewBox="0 0 24 24" fill="none" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 8h13v6a5 5 0 0 1-5 5H8a5 5 0 0 1-5-5V8Z"/><path d="M16 9h2.2a2.5 2.5 0 0 1 0 5H16"/><path d="M7 2v2.6M11 2v2.6"/></svg>';
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M8 12.4l2.6 2.6L16 9.4"/></svg>';

  var GIFT_PROP = '_cb_coffee_gift';   // marks a line as one we added
  var SELECTOR = '.cb-coffee-bar';
  var busy = false;

  function money(cents) {
    return 'R' + (cents / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  function isGift(line) {
    return !!(line.properties && line.properties[GIFT_PROP]);
  }

  /* Cart total with our own gift lines taken back out. */
  function qualifyingTotal(cart) {
    return cart.items.reduce(function (sum, line) {
      return isGift(line) ? sum - line.original_line_price : sum;
    }, cart.total_price);
  }

  /* Which tiers should be in the cart at this spend. */
  function earned(total) {
    var hit = TIERS.filter(function (t) { return total >= t.threshold; });
    if (CUMULATIVE || hit.length < 2) return hit;
    return [hit[hit.length - 1]];          // exclusive: best rung only
  }

  function render(cart) {
    var nodes = document.querySelectorAll(SELECTOR);
    if (!nodes.length) return;

    var total = qualifyingTotal(cart);
    var next = TIERS.find(function (t) { return total < t.threshold; });
    var got = earned(total);

    // One continuous scale across the WHOLE ladder, not per-rung: at R2 000 a
    // segmented bar says "R1 000 more for a 40mg" and never reveals that a
    // second, bigger reward exists at all.
    var max = TIERS[TIERS.length - 1].threshold;
    var text, done = !next;

    if (next) {
      var parts = [];
      if (got.length) {
        parts.push('Free ' + got[got.length - 1].short + ' ' + BRAND + ' unlocked');
      }
      parts.push(money(next.threshold - total) + ' more for a free ' +
                 next.short + ' sachet of ' + BRAND);
      // Still below the first rung - name the top of the ladder too.
      if (!got.length && TIERS.length > 1) {
        parts.push(money(max - total) + ' more for a ' + allTiersLabel());
      }
      text = parts.join(' \u00b7 ');
    } else {
      // Shopify applies automatic discounts at CHECKOUT, not in the cart, so
      // the line still shows its full price here. Say so rather than claiming
      // "free" next to a R160 line.
      text = (got.length > 1 ? allTiersLabel() + ' added'
                             : 'Free ' + got[0].short + ' ' + BRAND + ' added')
           + ' \u2014 discount applies at checkout';
    }

    nodes.forEach(function (el) {
      el.innerHTML =
        '<div class="free-delivery-bar__toolbar cb-coffee-bar__toolbar body2' +
        (done ? ' is-complete' : '') + '" ' +
        'style="--length:' + Math.min(total, max) + ';--max-length:' + max +
        ';--tier1:' + (TIERS[0].threshold / max * 100) + '%;">' +
        '<span class="cb-coffee-bar__icon">' + (done ? TICK : CUP) + '</span>' +
        '<span>' + text + '</span>' +
        '</div>' +
        '<div class="cb-coffee-bar__scale" aria-hidden="true">' +
        '<span class="' + (total >= TIERS[0].threshold ? 'is-past' : '') + '"' +
          ' style="left:' + (TIERS[0].threshold / max * 100) + '%">' +
          TIERS[0].label.replace(' sachet', '') + '</span>' +
        '<span class="cb-coffee-bar__scale-end ' + (done ? 'is-past' : '') + '"' +
          ' style="left:100%">' +
          TIERS[1].label.replace(' sachet', '') + '</span>' +
        '</div>';
      el.hidden = false;
    });
  }

  /* Section ids the theme has rendered for the cart, so a mutation can ask
   * Shopify to hand back fresh HTML for them in the same round trip. */
  function cartSectionIds() {
    return Array.prototype.slice
      .call(document.querySelectorAll('[id^="shopify-section-"]'))
      .map(function (el) { return el.id.replace('shopify-section-', ''); })
      .filter(function (id) { return /cart/i.test(id); });
  }

  /* Swap in the re-rendered sections. Without this the sachet sits in the cart
   * server-side but never appears in the member's item list until they reload. */
  function applySections(res) {
    if (!res || !res.sections) return;
    var doc = new DOMParser();
    Object.keys(res.sections).forEach(function (id) {
      var html = res.sections[id];
      var host = document.getElementById('shopify-section-' + id);
      if (!host || !html) return;
      var fresh = doc.parseFromString(html, 'text/html')
                     .getElementById('shopify-section-' + id);
      if (fresh) host.innerHTML = fresh.innerHTML;
    });
  }

  function change(line, quantity) {
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: line, quantity: quantity, sections: cartSectionIds().join(',') }),
    }).then(function (r) { return r.json(); }).then(function (res) {
      applySections(res); return res;
    });
  }

  function add(tier) {
    var props = {};
    props[GIFT_PROP] = tier.label;
    props['Free gift'] = 'unlocked at ' + money(tier.threshold) + ' \u2014 discount applies at checkout';
    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: tier.id, quantity: 1, properties: props }],
        sections: cartSectionIds().join(','),
      }),
    }).then(function (r) { return r.json(); }).then(function (res) {
      applySections(res); return res;
    });
  }

  /* Bring the cart's gift lines in line with what the spend has earned.
   * Returns a promise resolving true when the cart was mutated. */
  function reconcile(cart) {
    var total = qualifyingTotal(cart);
    var want = earned(total).map(function (t) { return t.id; });

    // Drop a gift that is no longer earned (or a duplicate of one that is).
    var seen = [];
    var stale = cart.items.filter(function (line) {
      if (!isGift(line)) return false;
      var keep = want.indexOf(line.variant_id) !== -1 && seen.indexOf(line.variant_id) === -1;
      if (keep) seen.push(line.variant_id);
      return !keep;
    });
    if (stale.length) return change(stale[0].key, 0).then(function () { return true; });

    // A gift line that crept above quantity 1.
    var fat = cart.items.find(function (l) { return isGift(l) && l.quantity > 1; });
    if (fat) return change(fat.key, 1).then(function () { return true; });

    // Add the first earned tier that is missing.
    var missing = earned(total).find(function (t) { return seen.indexOf(t.id) === -1; });
    if (missing) return add(missing).then(function () { return true; });

    return Promise.resolve(false);
  }

  function sync() {
    if (busy) return;
    busy = true;
    fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        render(cart);
        return reconcile(cart);
      })
      .then(function (changed) {
        busy = false;
        // A mutation changes the cart, so re-read once and refresh the theme's
        // own cart sections. No loop: the next pass finds nothing to do.
        if (changed) { refreshCartSections(); sync(); }
      })
      .catch(function () { busy = false; });
  }

  /* Ask the theme to re-render its cart UI after we changed the cart. */
  function refreshCartSections() {
    document.dispatchEvent(new CustomEvent('cb:cart:updated'));
    var drawer = document.querySelector('cart-drawer, cart-drawer-items');
    if (drawer && typeof drawer.onCartUpdate === 'function') drawer.onCartUpdate();
  }

  var debounce;
  function schedule() {
    clearTimeout(debounce);
    debounce = setTimeout(sync, 250);
  }

  function start() {
    if (!document.querySelector(SELECTOR)) return;
    sync();

    // The theme posts to these on every quantity change / add-to-cart.
    ['cart:updated', 'cart:refresh', 'cb:cart:updated'].forEach(function (evt) {
      document.addEventListener(evt, schedule);
    });

    // Dawn-family themes swap cart HTML rather than firing an event, so watch
    // the cart containers for replaced subtrees.
    var host = document.querySelector('#CartDrawer, #main-cart-items, cart-drawer');
    if (host && window.MutationObserver) {
      new MutationObserver(schedule).observe(host, { childList: true, subtree: true });
    }

    // Catch fetches the theme makes to the cart endpoints.
    var _fetch = window.fetch;
    window.fetch = function () {
      var url = arguments[0] && arguments[0].url ? arguments[0].url : String(arguments[0]);
      var p = _fetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(schedule, function () {});
      return p;
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
